import { Injectable, computed, signal } from '@angular/core';

interface ConfirmationDialogOptions {
  message: string;
  onOk?: () => void;
  onReject?: () => void;
  title?: string;
  type: 'danger' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  private visible = signal(false);
  private options = signal<ConfirmationDialogOptions | null>(null);

  readonly isVisible = computed(() => this.visible());
  readonly dialogOptions = computed(() => this.options());

  confirm(options: ConfirmationDialogOptions) {
    this.options.set(options);
    this.visible.set(true);
  }

  accept() {
    const opt = this.options();
    opt?.onOk?.();
    this.close();
  }

  reject() {
    const opt = this.options();
    opt?.onReject?.();
    this.close();
  }

  close() {
    this.visible.set(false);
    this.options.set(null);
  }
}
